module.exports = __webpack_public_path__ + "img/course_cate_00.2c2d3e56.png";